export default __webpack_public_path__ + "static/media/Digitall_classroom_website_icon_01.7b7d6ca5.svg";